import { render, staticRenderFns } from "./TasksItem.vue?vue&type=template&id=60f92610"
import script from "./TasksItem.vue?vue&type=script&lang=js"
export * from "./TasksItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports